import { apiGet, GetAdminUsersResponse } from 'api';

export const getAdminUsers = (): Promise<GetAdminUsersResponse> =>
  apiGet<GetAdminUsersResponse>('adminusers');
